import React from "react";
import { StaticImage } from "gatsby-plugin-image";

import support from '../../assets/images/support.png'
import attention from '../../assets/images/attention.png'
import application from '../../assets/images/application.png'

const BeneficiosList = () => {
  return (
    <>
      <div className="media">
        <img src={support} alt="support" />
        <div className="media-body">
          <h5 className="mt-0">Atención personalizada 24/7</h5>
          <p>
            Contamos con atención 24/7 vía correo, chat o sitio web con nuestro
            equipo de asesores y ajustadores.
          </p>
        </div>
      </div>
      <div className="media">
        <img src={attention} alt="attention" />
        <div className="media-body">
          <h5 className="mt-0">Notificaciones</h5>
          <p>Recibe notificaciones de avisos de pago y vencimientos.</p>
        </div>
      </div>
      <div className="media">
        <img
          src={application}
          alt="application"
        />
        <div className="media-body">
          <h5 className="mt-0">Control de pólizas</h5>
          <p>
            Guarda la información de tus pólizas para poder comparar precios,
            consultar y gestionar información en cualquier momento.
          </p>
        </div>
      </div>
    </>
  );
};

export default BeneficiosList;
